var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../config/frontend/nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );




var shim = require("/app/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/components/MenuLeft/MenuLeft.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/utils/macros.jinja", false, "assets/app/front/components/MenuLeft/MenuLeft.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(Object.prototype.hasOwnProperty.call(t_1, "svgSprite")) {
var t_4 = t_1.svgSprite;
} else {
cb(new Error("cannot import 'svgSprite'")); return;
}
context.setVariable("svgSprite", t_4);
output += "\n\n";
var macro_t_5 = runtime.makeMacro(
[], 
["classes", "subpage"], 
function (kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
frame.set("classes", Object.prototype.hasOwnProperty.call(kwargs, "classes") ? kwargs["classes"] : "");frame.set("subpage", Object.prototype.hasOwnProperty.call(kwargs, "subpage") ? kwargs["subpage"] : "");var t_6 = "";t_6 += "\n    <nav class=\"MenuLeft ";
t_6 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "classes"), env.opts.autoescape);
t_6 += "\">\n        <a class=\"MenuLeft-item ";
if(runtime.contextOrFrameLookup(context, frame, "subpage") == "about") {
t_6 += "isActive";
;
}
t_6 += "\" href=\"";
t_6 += runtime.suppressValue((lineno = 4, colno = 92, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url"), "url", context, ["front:about"])), env.opts.autoescape);
t_6 += "\">";
t_6 += runtime.suppressValue((lineno = 4, colno = 116, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["О нас"])), env.opts.autoescape);
t_6 += "</a>\n        <a class=\"MenuLeft-item ";
if(runtime.contextOrFrameLookup(context, frame, "subpage") == "history") {
t_6 += "isActive";
;
}
t_6 += "\" href=\"";
t_6 += runtime.suppressValue((lineno = 5, colno = 94, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url"), "url", context, ["front:history"])), env.opts.autoescape);
t_6 += "\">";
t_6 += runtime.suppressValue((lineno = 5, colno = 120, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["История"])), env.opts.autoescape);
t_6 += "</a>\n        <a class=\"MenuLeft-item ";
if(runtime.contextOrFrameLookup(context, frame, "subpage") == "principles") {
t_6 += "isActive";
;
}
t_6 += "\" href=\"";
t_6 += runtime.suppressValue((lineno = 6, colno = 97, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url"), "url", context, ["front:principles"])), env.opts.autoescape);
t_6 += "\">";
t_6 += runtime.suppressValue((lineno = 6, colno = 126, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["Принципы"])), env.opts.autoescape);
t_6 += "</a>\n        <a class=\"MenuLeft-item ";
if(runtime.contextOrFrameLookup(context, frame, "subpage") == "people") {
t_6 += "isActive";
;
}
t_6 += "\" href=\"";
t_6 += runtime.suppressValue((lineno = 7, colno = 93, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url"), "url", context, ["front:people"])), env.opts.autoescape);
t_6 += "\">";
t_6 += runtime.suppressValue((lineno = 7, colno = 118, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["Люди"])), env.opts.autoescape);
t_6 += "</a>\n    </nav>\n    ";
t_6 += runtime.suppressValue((lineno = 9, colno = 13, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "caller"), "caller", context, [])), env.opts.autoescape);
t_6 += "\n";
;
frame = callerFrame;
return new runtime.SafeString(t_6);
});
context.addExport("MenuLeft");
context.setVariable("MenuLeft", macro_t_5);
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/components/MenuLeft/MenuLeft.jinja"] , dependencies)